export default {
  minutesToStr: (minutesIn: number) => {
    if (!minutesIn) {
      return;
    }

    let resultStr = '';

    if (minutesIn > 59) {
      const hours = parseInt(`${minutesIn / 60}`);
      const minutes = minutesIn - hours * 60;

      resultStr = `${hours} ч`;

      if (minutes > 0) {
        resultStr += ` ${minutes} мин`;
      }
    } else {
      resultStr = `${minutesIn} мин`;
    }

    return resultStr;
  }
};
